import Environment from '../../../Environment';
import BaseService, { IHttpResponse, buildUrl } from '../../BaseService';

const RESOURCE = 'attendances-multiple';

interface IEmbeddedAttendance {
  ['end-user']: { id: string };
  session: { id: string };
}

export interface IAttendanceRequest {
  app_key: string;
  attended: boolean;
  _embedded: IEmbeddedAttendance;
}

export interface ICreateAttendancesMultipleRequest {
  token: string;
  attendances: IAttendanceRequest[];
}

export interface IAttendanceResponse {
  id: string;
  app_key: string;
  attended: boolean;
  org_key: string;
  created_at: string;
  updated_at: string;
  _embedded: IEmbeddedAttendance;
}

export interface ICreateAttendancesMultipleResponse extends IHttpResponse {
  body?: IAttendanceResponse[];
}

export default async ({
  token,
  attendances,
}: ICreateAttendancesMultipleRequest): Promise<ICreateAttendancesMultipleResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
    pluralizeResource: false,
  });

  return BaseService.Post({
    url,
    token,
    data: attendances,
  });
};
